import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const prevLocation = useRef(null);

  useEffect(() => {
    const currentLocation = pathname + search;
    
    // Always clear hash on any location change
    if (window.location.hash) {
      window.location.hash = "";
    }
    
    // Scroll to top when pathname or search params change (or on first render)
    if (prevLocation.current === null || prevLocation.current !== currentLocation) {
      // Instant scroll to top (no smooth animation)
      // Use multiple methods to ensure it works across all browsers
      window.scrollTo(0, 0);
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
      
      // Force scroll using requestAnimationFrame for better reliability
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        if (document.documentElement) {
          document.documentElement.scrollTop = 0;
        }
        if (document.body) {
          document.body.scrollTop = 0;
        }
      });
    }
    
    prevLocation.current = currentLocation;
  }, [pathname, search]);

  // Additional effect to handle hash changes
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash) {
        window.location.hash = "";
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return null;
};

export default ScrollToTop;
